(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
  btn.addEventListener('click', function() {
    window.location.href = btn.dataset.removeUrl;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {

    var isMobile = function () { return window.innerWidth <= 900; };

    // ── Mobile nav drawer open / close ────────────────────────
    var toggle  = document.querySelector('.header__menu-toggle');
    var drawer  = document.getElementById('mobile-nav-drawer');
    var overlay = document.getElementById('nav-overlay');

    function openMenu() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      closeMiniCart();
    }

    toggle.addEventListener('click', openMenu);
    overlay.addEventListener('click', closeMenu);
    drawer.querySelector('.nav-drawer__close').addEventListener('click', closeMenu);

    // ── Level 1 → 2: Shop expand / collapse ───────────────────
    drawer.querySelectorAll('.nav-drawer__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var children = btn.closest('.nav-drawer__item').querySelector('.nav-drawer__children');
        btn.setAttribute('aria-expanded', String(!expanded));
        children.classList.toggle('is-open', !expanded);
        children.setAttribute('aria-hidden', String(expanded));
      });
    });

    // ── Level 2 → 3: Category expand / collapse ───────────────
    drawer.querySelectorAll('.nav-drawer__sub-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var grandchildren = btn.closest('.nav-drawer__subitem').querySelector('.nav-drawer__grandchildren');
        btn.setAttribute('aria-expanded', String(!expanded));
        grandchildren.classList.toggle('is-open', !expanded);
        grandchildren.setAttribute('aria-hidden', String(expanded));
      });
    });

    // ── Desktop: mega-menu open/close with delay ──────────────
    var megaMenu = document.getElementById('shop-mega-menu');
    if (megaMenu) {
      var cats   = megaMenu.querySelectorAll('.mega-menu__cat[data-cat]');
      var panels = megaMenu.querySelectorAll('.mega-menu__panel[data-panel]');
      var shopItem = document.querySelector('.nav-item--has-dropdown');
      var shopLink = shopItem ? shopItem.querySelector('.header__nav-link') : null;
      var menuCloseTimer = null;
      var CLOSE_DELAY = 350;

      function activateCat(id) {
        cats.forEach(function (c) { c.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        var cat   = megaMenu.querySelector('.mega-menu__cat[data-cat="' + id + '"]');
        var panel = megaMenu.querySelector('.mega-menu__panel[data-panel="' + id + '"]');
        if (cat)   cat.classList.add('is-active');
        if (panel) panel.classList.add('is-active');
      }

      function openMegaMenu() {
        clearTimeout(menuCloseTimer);
        if (shopItem) shopItem.classList.add('mega-menu-is-open');
        if (shopLink) shopLink.setAttribute('aria-expanded', 'true');
      }

      function closeMegaMenu(returnFocus) {
        clearTimeout(menuCloseTimer);
        if (shopItem) shopItem.classList.remove('mega-menu-is-open');
        if (shopLink) shopLink.setAttribute('aria-expanded', 'false');
        if (returnFocus && shopLink) shopLink.focus();
      }

      function scheduleMegaMenuClose() {
        clearTimeout(menuCloseTimer);
        menuCloseTimer = setTimeout(function () { closeMegaMenu(false); }, CLOSE_DELAY);
      }

      cats.forEach(function (cat) {
        cat.addEventListener('mouseenter', function () { activateCat(cat.dataset.cat); });
      });

      if (shopItem) {
        shopItem.addEventListener('mouseenter', function () {
          openMegaMenu();
          activateCat('furniture');
        });
        shopItem.addEventListener('mouseleave', scheduleMegaMenuClose);
      }

      // Keyboard: Enter/Space on Shop link toggles mega menu
      if (shopLink) {
        shopLink.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          if (shopItem.classList.contains('mega-menu-is-open')) {
            closeMegaMenu(true);
          } else {
            openMegaMenu();
            activateCat('furniture');
            var first = megaMenu.querySelector('a[href], button, input');
            if (first) setTimeout(function () { first.focus(); }, 50);
          }
        });
      }

      // Focus trap + Escape inside mega menu
      megaMenu.addEventListener('keydown', function (e) {
        if (!shopItem.classList.contains('mega-menu-is-open')) return;
        if (e.key === 'Escape') { closeMegaMenu(true); return; }
        if (e.key !== 'Tab') return;
        var focusable = Array.from(megaMenu.querySelectorAll('a[href], button, input')).filter(function (el) {
          return el.offsetParent !== null;
        });
        if (!focusable.length) return;
        if (e.shiftKey && document.activeElement === focusable[0]) {
          e.preventDefault();
          closeMegaMenu(true);
        } else if (!e.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
          closeMegaMenu(false);
        }
      });
    }

    // ── Search overlay ─────────────────────────────────────────
    var searchBtn     = document.getElementById('header-search-btn');
    var searchOverlay = document.getElementById('search-overlay');
    var searchClose   = document.getElementById('search-overlay-close');
    var searchInput   = document.getElementById('search-overlay-input');

    function openSearch() {
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Small delay so transition plays before focus moves
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
    }
    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    var searchBtnMobile = document.getElementById('header-search-btn-mobile');
    var drawerSearchBtn = document.getElementById('drawer-search-btn');
    if (searchBtn)       searchBtn.addEventListener('click', openSearch);
    if (searchBtnMobile) searchBtnMobile.addEventListener('click', openSearch);
    if (drawerSearchBtn) drawerSearchBtn.addEventListener('click', function () { closeMenu(); openSearch(); });
    if (searchClose)     searchClose.addEventListener('click', closeSearch);

    // Close search on backdrop click (not inner box)
    if (searchOverlay) {
      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) closeSearch();
      });
    }

    // Close search on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
        if (miniCart && miniCart.classList.contains('is-open')) closeMiniCart();
      }
    });

    // ── Mini cart ──────────────────────────────────────────────
    var cartWrap  = document.getElementById('cart-wrap');
    var cartIcon  = document.getElementById('cart-icon');
    var miniCart  = document.getElementById('mini-cart');
    var miniCartCloseTimer = null;

    function openMiniCart() {
      if (!miniCart) return;
      clearTimeout(miniCartCloseTimer);
      miniCart.classList.add('is-open');
      miniCart.setAttribute('aria-hidden', 'false');
    }
    function closeMiniCart() {
      if (!miniCart) return;
      clearTimeout(miniCartCloseTimer);
      miniCart.classList.remove('is-open');
      miniCart.setAttribute('aria-hidden', 'true');
    }

    function refreshMiniCart() {
      fetch('/?sections=header')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.header, 'text/html');

          // Swap badge count
          var newBadge = doc.querySelector('.cart-badge');
          var oldBadge = document.querySelector('.cart-badge');
          if (newBadge) {
            if (oldBadge) {
              oldBadge.textContent = newBadge.textContent;
            } else {
              var iconEl = document.getElementById('cart-icon');
              if (iconEl) iconEl.insertAdjacentHTML('beforeend', newBadge.outerHTML);
            }
          }

          // Swap mini cart inner HTML (event delegation survives this)
          var newMiniCart = doc.getElementById('mini-cart');
          if (newMiniCart && miniCart) {
            miniCart.innerHTML = newMiniCart.innerHTML;
          }

          // Show mini cart briefly on desktop
          if (window.innerWidth > 900) {
            openMiniCart();
            miniCartCloseTimer = setTimeout(function () { closeMiniCart(); }, 3000);
          }
        });
    }
    window.refreshMiniCart = refreshMiniCart;

    // Hover: mouseenter/mouseleave
    if (cartWrap && miniCart) {
      cartWrap.addEventListener('mouseenter', function () { openMiniCart(); });
      cartWrap.addEventListener('mouseleave', function () {
        miniCartCloseTimer = setTimeout(function () { closeMiniCart(); }, 200);
      });
    }

    // Event delegation inside mini cart — survives innerHTML refresh
    if (miniCart) {
      miniCart.addEventListener('click', function (e) {
        if (e.target.closest('.mini-cart__close')) {
          closeMiniCart();
          return;
        }
        var removeBtn = e.target.closest('.mini-cart__item-remove');
        if (removeBtn && !removeBtn.disabled) {
          e.preventDefault();
          removeBtn.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: removeBtn.dataset.itemKey, quantity: 0 })
          }).then(function () { refreshMiniCart(); });
        }
      });

      miniCart.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && miniCart.classList.contains('is-open')) closeMiniCart();
      });
    }

    // Close mini cart when clicking outside
    document.addEventListener('click', function (e) {
      if (!cartWrap) return;
      if (!miniCart || !miniCart.classList.contains('is-open')) return;
      if (!cartWrap.contains(e.target)) closeMiniCart();
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about"]) return;
  try {
    
  (function () {
    var page = document.querySelector('.about-page');
    if (!page) return;

    var items = page.querySelectorAll('.reveal');
    if (!items.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    items.forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {

  // ── Slideshow ────────────────────────────────────────────────
  var slides = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__slide'));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__thumb'));
  var prevBtn = document.querySelector('.gallery-arrow--prev');
  var nextBtn = document.querySelector('.gallery-arrow--next');
  var current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (thumbs[current]) thumbs[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (thumbs[current]) {
      thumbs[current].classList.add('is-active');
      thumbs[current].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goTo(parseInt(thumb.dataset.index, 10));
    });
  });

  // ── Variant select: update price + ATC state ─────────────────
  var variantSelect = document.getElementById('variant-select');
  var priceRow = document.getElementById('product-price');
  var atcBtn = document.getElementById('product-atc');

  if (variantSelect && priceRow && atcBtn) {
    variantSelect.addEventListener('change', function () {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var price = parseInt(selected.dataset.price, 10);
      var comparePrice = parseInt(selected.dataset.comparePrice, 10);
      var available = selected.dataset.available === 'true';

      var priceEl = priceRow.querySelector('.product-info__price');
      var compareEl = priceRow.querySelector('.product-info__compare-price');
      var soldBadge = priceRow.querySelector('.product-info__sold-badge');
      var shippingBadge = priceRow.querySelector('.product-info__shipping-badge');

      if (available) {
        // Show price; hide/remove sold badge
        if (!priceEl) {
          priceEl = document.createElement('span');
          priceEl.className = 'product-info__price';
          // insert before shipping badge if present, else append
          priceRow.insertBefore(priceEl, shippingBadge || null);
        }
        priceEl.textContent = formatMoney(price);

        if (comparePrice > price) {
          if (!compareEl) {
            compareEl = document.createElement('s');
            compareEl.className = 'product-info__compare-price';
            priceRow.insertBefore(compareEl, priceEl);
          }
          compareEl.textContent = formatMoney(comparePrice);
        } else if (compareEl) {
          compareEl.remove();
        }

        if (soldBadge) soldBadge.remove();
      } else {
        // Hide price + compare; show sold badge
        if (priceEl) priceEl.remove();
        if (compareEl) compareEl.remove();
        if (!soldBadge) {
          var badge = document.createElement('span');
          badge.className = 'product-info__sold-badge';
          badge.textContent = 'Sold';
          priceRow.insertBefore(badge, shippingBadge || null);
        }
      }

      atcBtn.disabled = !available;
      atcBtn.classList.toggle('product-form__atc--soldout', !available);
      atcBtn.textContent = available ? 'Add to Cart' : 'Sold';
    });
  }

  // ── ATC: AJAX with loading/success state ────────────────────
  var productForm = document.getElementById('product-form');

  if (productForm && atcBtn) {
    productForm.addEventListener('submit', function (e) {
      if (atcBtn.disabled) return;
      e.preventDefault();

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(productForm)
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        atcBtn.textContent = 'Added ✓';
        if (window.refreshMiniCart) window.refreshMiniCart();
        setTimeout(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        }, 1500);
      })
      .catch(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      });
    });
  }

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── Mobile back link ─────────────────────────────────────────
  var backLink = document.getElementById('product-back-link');
  if (backLink && history.length > 1) {
    backLink.addEventListener('click', function (e) {
      e.preventDefault();
      history.back();
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.slideshow[data-autoplay]').forEach(function (el) {
      var track = el.querySelector('.slideshow__track');
      var dots = el.querySelectorAll('.slideshow__dot');
      var total = el.querySelectorAll('.slideshow__slide').length;
      var current = 0;
      var timer = null;

      function goTo(index) {
        current = (index + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === current);
        });
      }

      el.querySelector('.slideshow__prev').addEventListener('click', function () {
        reset(); goTo(current - 1);
      });
      el.querySelector('.slideshow__next').addEventListener('click', function () {
        reset(); goTo(current + 1);
      });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { reset(); goTo(i); });
      });

      function start() {
        var delay = parseInt(el.dataset.delay, 10) || 4000;
        timer = setInterval(function () { goTo(current + 1); }, delay);
      }
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function reset() {
        clearInterval(timer);
        if (el.dataset.autoplay === 'true' && !prefersReduced) start();
      }

      if (el.dataset.autoplay === 'true' && !prefersReduced) start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
